import App from "./App.ce.vue";

export function setup() {
  return { component: App, plugins: [] };
}
